import React from "react";
import "./service_com_2.css";

const DescriptionSection = () => {
  return (
    <section className="desc-section">
      <div className="desc-container">
        <h1>💫 What We Check in Compatibility</h1>
        <ul>
          
<li>We go beyond basic matching and study all important factors that define the strength of a bond:
</li>
<li>Guna Matching & Nadi Dosh Check – to see emotional harmony and health balance.

</li>
<li>
Moon & Ascendant Compatibility – to understand mental connection and long-term understanding.
</li>
<li>Overall Nature & Lifestyle Matching – to check how both individuals will adjust together in daily life.
</li>
<li>Future Married Life Stability – to see if the relationship can stay peaceful and supportive over time.
</li>

<li>
Children & Family Compatibility – to ensure there are no planetary issues that may affect future family life.
</li>
<p>Our detailed analysis helps you know whether the relationship will grow into a lasting marriage or if it’s just a temporary phase.</p>

        </ul>
        {/* <p>
          Lorem ipsum dolor sit amet consectetur. Pellentesque nascetur sed
          tellus ut vehicula eu consectetur elit at. Nulla erat nunc nisl duis
          sed cras semper vitae. Tempor odio ullamcorper non sed id nisi sed
          egestas et egestas fusce arcu. Sapien sit tellus faucibus sed nec nibh
          risus dissemismod eget. Tortor maecenas quam placerat volutpat varius
          tristique sed velit.
        </p>
        <p>
          Vestibulum faucibus in libero gravida condimentum non arcu feugiat
          facilisis. Et tristique et facilisi sit amet. Consectetur congue
          ridiculus odio aliquet praesent quis. Mattis orci ut elementum
          faucibus in nec eu. Vestibulum in rhoncus egestas facilisis integer in
          adipiscing enim. Dignissim amet scelerisque posuere quis. Etiam rhoncus
          et leo nulla.
        </p>
        <p>
          Volutpat commodo orci sit viverra mauris nibh turpis nulla. Enim
          ultrices semper urna arcu nibh. Habitant tristique non bibendum ut
          vitae amet est. Iaculis ipsum tempus sociis vitae in. Finibus laoreet
          iaculis ut massa.
        </p>
        <p>
          Lectus ut neque quam turpis blandit ipsum vitae sit. Feugiat odio
          gravida feugiat tincidunt. Scelerisque non nisi arcu in molestie purus
          tempor. Viverra interdum ut enim sodales et convallis nunc.
        </p>
        <p>
          Lorem pretium feugiat tincidunt laoreet. Vitae volutpat augue libero a
          ullamcorper elit facilisi feugiat mauris. Rhoncus id ultricies orci
          diam ornare eu habitant.
        </p> */}
      </div>
    </section>
  );
};

export default DescriptionSection;
